import { graphMutation } from '@services/commService';

export const adminUpdateUserMfa = async (userId, method) => {
  const mutation = `
    mutation AdminUpdateUserMfa($userId: String!, $method: String!) {
      adminUpdateUserMfa(userId: $userId, method: $method) {
        success
        blockedReason
      }
    }
  `;
  const res = await graphMutation(mutation, {
    userId,
    method: String(method || '').trim().toUpperCase(),
  }, true);
  return res?.data?.adminUpdateUserMfa;
};

export const adminUpdateUserPhone = async (userId, phoneNumber) => {
  const mutation = `
    mutation AdminUpdateUserPhone($userId: String!, $phoneNumber: String) {
      adminUpdateUserPhone(userId: $userId, phoneNumber: $phoneNumber) {
        success
        phone
        cognitoSynced
        blockedReason
      }
    }
  `;
  const res = await graphMutation(mutation, {
    userId,
    phoneNumber: String(phoneNumber || '').trim() || null,
  }, true);
  return res?.data?.adminUpdateUserPhone;
};

export const adminUpdateUserName = async (userId, firstName, lastName) => {
  const mutation = `
    mutation AdminUpdateUserName($userId: String!, $firstName: String!, $lastName: String!) {
      adminUpdateUserName(userId: $userId, firstName: $firstName, lastName: $lastName) {
        success
        firstName
        lastName
      }
    }
  `;
  const res = await graphMutation(mutation, { userId, firstName, lastName }, true);
  return res?.data?.adminUpdateUserName;
};

export const adminUpdateUserBirthdate = async (userId, birthdate) => {
  const mutation = `
    mutation AdminUpdateUserBirthdate($userId: String!, $birthdate: String!) {
      adminUpdateUserBirthdate(userId: $userId, birthdate: $birthdate) {
        success
        birthdate
      }
    }
  `;
  const res = await graphMutation(mutation, { userId, birthdate }, true);
  return res?.data?.adminUpdateUserBirthdate;
};
